// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker {
  display: inline-flex;
}
.react-datepicker__input-container > input {
  width: 100%;
  min-height: 40px;
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  padding: 0 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom-datepicker.module.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;AAAJ;AAGE;EACE,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;AADJ","sourcesContent":[":global {\n  .react-datepicker {\n    display: inline-flex;\n  }\n\n  .react-datepicker__input-container > input {\n    width: 100%;\n    min-height: 40px;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 0.875rem;\n    padding: 0 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
